// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd40121b","833":"6a30fcf2"}[chunkId] + ".chunk.js";
};